import { css } from '@emotion/react';
import React, { useState, memo } from 'react';

import { TabTitle, TabSection } from '../../../../blocks';
import RatesSection from '../RatesSection';

/**
 * Collapsible Rates section of the Edit Order modal for admins, wrapping `RatesSection`.
 * Takes no props; `RatesSection` reads the order from `ModalContext`.
 */
const AdminRatesTab = memo(() => {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <>
            <TabTitle
                collapsed={collapsed}
                callbacks={{ setCollapsed }}
                css={css`
                    align-items: center;
                    justify-content: space-between;
                    ${collapsed ? '' : 'margin-bottom: 20px;'}
                `}
            >
                Rates
            </TabTitle>

            {collapsed ? null : (
                <>
                    <TabSection className="mt-3">Admin - Rates</TabSection>
                    <RatesSection />
                </>
            )}
        </>
    );
});

export default AdminRatesTab;
